import { Response } from '@marketplace-web/core-api/api-client-util'
import { transformUserDto } from '@marketplace-web/shared/user-data'
import { UserResp } from 'types/api/response/user-resp'

export const transformUserResponse = (response: Response<UserResp>) => ({
  user: transformUserDto(response.user),
})
